import { h, Component } from 'preact';
import { translate } from 'react-i18next';


class TwoFactorMethod extends Component {

  updateMethod = (e) => {
    this.setState({ select2FAMethod: e.target.value });
    this.props.update('method',e.target.value);
  }

  updateCountry = (e) => {
    this.setState({ select2FACountry: e.target.value });
    this.props.update('country',e.target.value);
    this.props.update('countryCode',e.target.options[e.target.selectedIndex].dataset.code);
  }

  constructor(props) {
  	super(props);
  	this.state = {
  		method: 'initial',
			country: 'initial',
      select2FAMethod: 'none',
      select2FACountry: 'none'
  	};
  }

  shouldComponentUpdate(nextProps) {
    if ( nextProps.twoFactorData !== undefined && this.state.select2FAMethod === 'none' ) {
      this.setState({select2FAMethod: nextProps.twoFactorData.validationOption.toLowerCase() });
    }
  }

  componentDidMount() {
      this.setState({ select2FAMethod: this.props.twoFactorData.validationOption.toLowerCase() });
  }

	render() {
    const { t } = this.props;
		return (
        <div className="c-TwoFactorMethod">
          <h4>{t('Preferred Notification Method')}</h4>
          <p>{t('Please select your preferred method of receiving your two-factor security code. Note that not all countries are supported in our text message notification method.')}</p>
          <select
            key="2fa-method" 
            id="2fa-method"
            onInput={this.updateMethod}
            value={this.state.select2FAMethod}
          >
            <option selected disabled value="none">{t('None')}</option>
            <option value="email">{t('Email')}</option>
            <option value="phone">{t('Phone')}</option>
            <option value="both">{t('Both')}</option>
          </select>
          <select
            key="2fa-country"
            id="2fa-country"
            onInput={this.updateCountry}
            value={this.state.select2FACountry}
          >
            <option selected disabled value="none">{t('Choose Country')}</option>
            <option data-code="+61" value="AU">{t('Australia')}</option>
            <option data-code="+32" value="BE">{t('Belgium')}</option>
            <option data-code="+55" value="BR">{t('Brazil')}</option>
            <option data-code="+1" value="CA">{t('Canada')}</option>
            <option data-code="+56" value="CL">{t('Chile')}</option>
            <option data-code="+358" value="FI">{t('Finland')}</option>
            <option data-code="+33" value="FR">{t('France')}</option>
            <option data-code="+49" value="DE">{t('Germany')}</option>
            <option data-code="+353" value="IR">{t('Ireland')}</option>
            <option data-code="+82" value="KR">{t('Korea')}</option>
            <option data-code="+52" value="MX">{t('Mexico')}</option>
            <option data-code="+31" value="NL">{t('Netherlands')}</option>
            <option data-code="+48" value="PL">{t('Poland')}</option>
            <option data-code="+351" value="PT">{t('Portugal')}</option>
            <option data-code="+34" value="ES">{t('Spain')}</option>
            <option data-code="+46" value="SE">{t('Sweden')}</option>
            <option data-code="+44" value="GB">{t('United Kingdom')}</option>
            <option data-code="+1" value="US">{t('United States of America')}</option>
            <option data-code="0" value="other">{t('Other')}</option>
          </select>
        </div>
		);
	}
}

export default translate(['common'], { withRef: true })(TwoFactorMethod);


// WEBPACK FOOTER //
// ./components/TwoFactorMethod.js